export default "/images/vendor/flag-icon-css/flags/4x3/um.svg?867207fe83a99a3b9b957f97b9245188";